export default class URLSearchParamsExtended extends URLSearchParams {
  constructor(init) {
    super(init)
  }

  /**
   * Overridden to allow arrays
   */
  toString() {
    let ret = ""
    for (const key of this.keys()) {
      for (const value of this.getAll(key)) {
        const isJSON = this._isJSON(value)
        if (isJSON) {
          if (ret) {
            ret += "&"
          }
          ret += `${key}=${value}`
        } else {
          for (const v of value.split(",")) {
            if (ret) {
              ret += "&"
            }
            ret += `${key}=${v}`
          }
        }
      }
    }
    return ret
  }

  _isJSON(o) {
    try {
      JSON.parse(o)
      return true
    } catch (e) {
      return false
    }
  }
}
